import { getFundraiser, loadValues, setValues } from 'actions/app'
import { getProducts } from 'actions/products'
import routes, { formatRoute } from 'config/routes'
import * as Pages from 'pages'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useParams,
} from 'react-router-dom'

function Support({
  fundraiser,
  getFundraiser,
  getProducts,
  loadValues,
  setValues,
}) {
  const [order, setOrder] = React.useState()
  const { shortcode } = useParams()
  const history = useHistory()

  React.useEffect(() => {
    const load = async () => {
      try {
        await getProducts(fundraiser.id)
        await loadValues(fundraiser.shortcode)
      } catch (err) {
        console.error('Error preparing fundraiser details')
        console.error(err)
      }
    }

    load()
  }, [fundraiser, getProducts, loadValues])

  const onFinish = (next) => (values) => {
    setValues(fundraiser.shortcode, values)
    history.push(formatRoute(next, { shortcode }))
  }

  const showOrder = (order) => {
    setOrder(order)
    history.push(formatRoute(routes.orderDetails, { shortcode }))
  }

  return (
    <Switch>
      <Route exact path={routes.getStarted}>
        <Pages.GetStarted onFinish={onFinish(routes.selectReward)} />
      </Route>
      <Route exact path={routes.selectReward}>
        <Pages.SelectReward onFinish={onFinish(routes.review)} />
      </Route>
      <Route exact path={routes.review}>
        <Pages.Review onFinish={showOrder} />
      </Route>
      <Route exact path={routes.orderDetails}>
        {!!order ? (
          <Pages.OrderDetails order={order} />
        ) : (
          <Redirect to={formatRoute(routes.getStarted, { shortcode })} />
        )}
      </Route>
      <Redirect to={formatRoute(routes.getStarted, { shortcode })} />
    </Switch>
  )
}

Support.propTypes = {
  fundraiser: PropTypes.object.isRequired,
  getProducts: PropTypes.func.isRequired,
  loadValues: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
}

const mapState = (state) => ({
  fundraiser: state.fundraiser,
})

const mapDispatch = {
  getFundraiser,
  getProducts,
  loadValues,
  setValues,
}

export default connect(mapState, mapDispatch)(Support)
